module.exports = __webpack_public_path__ + "static/media/reports_unselected.4d558cba.svg";